import { createSelector } from '@ngrx/store';
import { getBillingRateState } from '../store/store.selectors';
import { BillingRateStateInterface, selectAll } from './billing-rate.state';

export const getBillingRate = createSelector(
  getBillingRateState,
  (state: BillingRateStateInterface) => selectAll(state)
);
